import React from 'react';
import { Card, Title, Flex, Divider, Tab, TabGroup, TabList, TabPanel, TabPanels } from '@tremor/react';
import { UserGroupIcon, KeyIcon, ChartBarIcon } from '@heroicons/react/24/outline';

import Nav from '../../components/nav';
import AdminOAuthClients from './oauth/index';
import AdminUsers from './users/index';
import AdminUsage from './usage/index';

export default function Admin() {
  return (
    <div>
      <Nav />
      <main className="p-4 md:p-10 mx-auto max-w-7xl">
        <Flex>
          <div>
            <Title>Admin</Title>
          </div>
        </Flex>
        <Divider />
        
        <Card className="mt-6">
          <TabGroup>
            <TabList className="mb-6">
              <Tab icon={UserGroupIcon}>Users</Tab>
              <Tab icon={KeyIcon}>OAuth Clients</Tab>
              <Tab icon={ChartBarIcon}>Usage Statistics</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                {/* Using AdminUsers component without duplicated Nav */}
                <AdminUsers />
              </TabPanel>
              <TabPanel>
                {/* Using AdminOAuthClients component without duplicated Nav */}
                <AdminOAuthClients />
              </TabPanel>
              <TabPanel>
                {/* Using AdminUsage component for usage statistics */}
                <AdminUsage />
              </TabPanel>
            </TabPanels>
          </TabGroup>
        </Card>
      </main>
    </div>
  );
}

